'use strict';

import { decodeHtml } from '../../../_imports/utils/utils.common';
import { replaceAll } from "../../../../utils/utils";

import BaseVueComponent from '../../../_imports/shared/base-vue-component.vue.common';
import MediaImage from '../../../vue/media-image.main';
import MediaVideo from '../../../videos/media-video.main';
import MediaLogo from '../../../media/media-logo.main';
import CallToAction from '../../../cta/cta.vue';
import Countdown from '../../../countdown/_imports/countdown-resources.vue';
import MarketoForm from '../../../forms/_imports/marketo-form.vue';
import Modal from '../../../modal/modal.vue';
import ResourceSpeakers from './resource-speakers.vue';
import ResourceVideoPlaylist from './resource-video-playlist.vue';
import VideoChapters from './video-chapters.vue';
import VideoTranscript from './video-transcript.vue';
import VideoEndMessage from './video-end-message.vue';
import VideoIdleMessage from './video-idle-message.vue';
import SeriesVideoNextMessage from './series-video-next-message.vue';
import SeeMoreContent from "./see-more-content.vue.js";
import { OverlayScrollbars } from 'overlayscrollbars';
import ResourceVideo from '../../shared/resource-video.common';

export default {
    mixins: [
        BaseVueComponent,
        SeeMoreContent,
        ResourceVideo
    ],
    components: {
        ResourceSpeakers,
        MediaImage,
        MediaVideo,
        CallToAction,
        ResourceVideoPlaylist,
        Countdown,
        MarketoForm,
        Modal,
        MediaLogo,
        VideoEndMessage,
        VideoIdleMessage,
        SeriesVideoNextMessage,
        VideoChapters,
        VideoTranscript
    },
    data() {
        return {
            id: null,
            resource: {},
            videoPlayerHeight: 0,
            marginTopForm: null,
            resourceDocumentUrlForCta: null,
            resourceType: '',
            countdown: false,
            iconPosition: '',
            icon: '',
            arrowVisible: true,
            pageLayout: '',
            videoPlayer: null,
            lang: '',
        };
    },
    computed: {
        eventDisplayAddress() {
            return this.data.event.nextSession?.address || this.data.event.address;
        },
        eventDisplayDate() {
            return this.data.event.nextSession?.displayDate || this.data.event.displayDate;
        },
        eventDisplayTime() {
            return this.data.event.nextSession?.displayTime || this.data.event.displayTime;
        },
        endMessage() {
            return this.data.video?.messages?.end || this.data.series?.messages?.end;
        },
        hasSessions() {
            return this.data.event.sessions.length;
        },
        registrationIsNotClosedWithSessions() {
            return this.data.event.sessions.length && this.data.event.currentStatus !== 'RegistrationClosedAfterEvent';
        },
        withCountdownRegistrationOpen() {
            return this.data.event && this.data.event.countdownActivation === true  && this.data.event.currentStatus === 'RegistrationOpen' && !this.data.event.sessions.length !== 0;
        },
        registrationOpen() {
            return this.data.event.currentStatus === 'RegistrationOpen';
        },
        eventInProgress() {
            return this.data.event.currentStatus === 'InProgress';
        },
        registrationClosed() {
            return this.data.event.currentStatus === 'RegistrationClosedAfterEvent' && this.data.event.currentMessage;
        },
        registrationOpenFormNotFilledAndImg(){
            return this.data.resource.imageFullSize.src && this.data.event.currentStatus === 'RegistrationOpen' && !this.successMessage;
        },
        registrationClosedOrSuccessMessageWithImg(){
            return this.data.resource.imageFullSize.src && this.successMessage || this.data.resource.imageFullSize.src && this.data.event.currentStatus !== 'RegistrationOpen';
        },
        returningMessage() {
            let returningMessage =  this.data.resource.pageCtaTitle;
            const singularLabel = CoveoWebsite?.resource?.resource?.resourceType?.singularLabel;

            if (typeof CoveoWebsite !== 'undefined' && singularLabel) {
                returningMessage = replaceAll(returningMessage, '{resourceType}', singularLabel.toLowerCase());
            }

            return returningMessage;
        },
        dsTheme(){
            return this.data?.dsTheme || 'light';
        },
        dsBackgroundShade(){
            return this.data?.dsBackgroundShade || 'default';
        },
        isResourceVideo() {
            return this.data.video?.video?.videoCode;
        },
    },
    watch: {
        fullyLoaded() {
            setTimeout(() => {
                this.setFormY();
                this.moveFormInHero();

                this.$root.$on("successMessage", (data) => {
                    this.successMessage = data;
                });

                this.$root.$on("countdown-ended", () => {
                    this.countdown = false;
                    this.setFormY();
                });

                this.$root.$on("get-lead-success", () => {
                    this.getLeadSuccess = true;
                });

                this.$root.$on("show-form-fields-animation-begin", () => {
                    this.formFieldsVisible = true;

                    if(!this.getLeadSuccess && window.innerWidth > 1024) {
                        Velocity(document.body, 'scroll', {
                            duration: 1200,
                            easing: [1000, 80],
                            offset: 140,
                            complete: () => {
                                this.$refs?.formPlaceholder?.closest('.event-form').classList.add('form-fields-visible');
                            }
                        });
                    } else if(!this.getLeadSuccess) {
                        this.$refs?.formPlaceholder?.closest('.event-form').classList.add('form-fields-visible');
                    }
                });
            }, 0);
        }
    },
    created() {
        window.addEventListener("resize", this.onResize);

        this.$root.$on('countdown-activated', () => {
            this.countdown = true;
        });

        this.deleteMarketoCookie();

        if (!this.isGated()) {
            this.setCtaToResourceDocument();
        }
        
        CoveoWebsite.resource = this.data;
        
        if (this.isResourceVideo) {
            CoveoWebsite.videoApi.onReady(this.data.video.video.videoCode, (player) => {
                this.videoPlayer = player;
            });
        }

        this.$nextTick(() => {
            this.resourceCanBeViewed = this.isGated() ? this.hasMarketoCookie() && CoveoWebsite.forms.email : this.resourceCanBeViewed;

            if (!this.isGated() || this.hasMarketoCookie()) {
                this.arrowVisible = false;
                
                if (this.isResourceVideo
                    && 'razorPlayer' in this.$refs) {
                    this.prepareVideo();
                }
            }

            if (this.data) {
                this.resourceType = this.data?.resource?.resourceType?.label;
                this.iconPosition = this.data?.resource?.pageCtaIconPosition ? this.data?.resource?.pageCtaIconPosition : 'left';
                this.icon = this.data?.resource?.pageCtaIcon ? this.data?.resource?.pageCtaIcon : 'download';
                this.pageLayout = this.data?.resource?.pageLayout;
            }

            if (this.isSpecialReport() || this.isGartner()) {
                this.resourceDocumentUrlForCta = this.data.document;
            }
        });
    },
    mounted() {
        this.initSeriesVideoPage();
    },
    destroyed() {
        window.removeEventListener("resize", this.onResize);
    },
    methods: {
        onFullyLoadedComplete() {
            this.setFormY();
            this.moveFormInHero();
        },
        onFormFieldsVisible() {
            if(!this.getLeadSuccess && window.innerWidth > 1024) {
                Velocity(document.body, 'scroll', {
                    duration: 1200,
                    easing: [1000, 80],
                    offset: 140,
                    complete: () => {
                        this.$refs?.formPlaceholder?.closest('.event-form').classList.add('form-fields-visible');
                    }
                });
            } else if(!this.getLeadSuccess) {
                this.$refs?.formPlaceholder?.closest('.event-form').classList.add('form-fields-visible');
            }
        },
        onResize() {
            this.moveFormInHero();
            this.setFormY();
        },
        cleanUrl(url) {
            return url.replace(/(^\w+:|^)\/\//, '');
        },
        decodeHtml(html) {
            return decodeHtml(html);
        },
        hideArrow(){
            this.arrowVisible = false;
        },
        setVideoPlayerHeight(height) {
            this.videoPlayerHeight = height;
        },
        eventIsPast(eventDate) {
            return new Date(eventDate) < new Date();
        },
        showEventDescription(event) {
            const session = event.target.closest('[data-session]');

            if(session.className.includes('show-description')) {
                event.target.closest('[data-session]').classList.remove('show-description');

                return;
            }

            event.target.closest('[data-session]').classList.add('show-description');
        },
        setFormY() {
            if (this.$refs.heroContainer) {
                const heroHeight = this.$refs.heroContainer.offsetHeight;
                const heroPaddingTop = parseInt(window.getComputedStyle(this.$refs.heroContainer).getPropertyValue('padding-top'));
                const windowWidth = window.innerWidth;

                if (windowWidth > 1024) {
                    const totalHeight = (heroHeight / 2) + (this.$refs.formPlaceholder.offsetHeight / 2) + (heroPaddingTop / 2);

                    if(this.$refs.countdown && this.countdown) {
                        let countdownHeight = this.$refs.countdown.offsetHeight;
                        this.marginTopForm = -(totalHeight - countdownHeight);
                    } else if(this.formFieldsVisible) {
                        this.marginTopForm = -(heroHeight);
                    } else {
                        this.marginTopForm = -(totalHeight);
                    }
                } else {
                    this.marginTopForm = 48;
                }
            }
        },
        moveFormInHero() {
           if(this.pageLayout === 'event') {
                const windowWidth = window.innerWidth;
                const form = this.$refs?.resourceForm?.querySelector('[am-form]');
                const heroFormPlaceholder = this.$refs?.heroFormPlaceholder;

                if (windowWidth <= 1024) {
                    if(form) {
                        heroFormPlaceholder.append(form);
                    }
                } else if(heroFormPlaceholder.querySelector('[am-form]')) {
                    this.$refs?.resourceForm.append(heroFormPlaceholder.querySelector('[am-form]'));
                }
            }
        },
        isGated() {
            return this.data && this.data.resource && this.data.resource.gatedContent === 'always';
        },
        isSpecialReport(){
            return this.data && this.data.resource.pageLayout === "special-report";
        },
        isGartner(){
            return this.data && this.data.resource.pageLayout.includes('gartner');
        },
        isR360HubWebinar() {
            return this.data?.resource?.pageLayout === 'r360-hub-webinar';
        },
        isDemoHub() {
            return this.data?.resource?.pageLayout === 'demo-hub';
        },
        setCtaToResourceDocument() {
            if (this.data) {
                this.resourceDocumentUrlForCta = this.data.document;
            }
        },
        ctaClick() {
            if (this.ctaClickAfterCloseModal) {
                this.ctaClickAfterCloseModal = false;

                return;
            }

            const isVideo = this.isResourceVideo && this.$refs.videoPlayer;
            let shouldOpenResource = false;

            if (this.isGated()) {
                if (this.hasMarketoCookie()
                    && CoveoWebsite.forms.email) {
                    if (isVideo) {
                        shouldOpenResource = true;
                    } else {
                        this.setCtaToResourceDocument();
                        this.updateMarketoLeadAndPushDataLayer();
                    }
                } else if (this.$refs.formModal) {
                    this.$refs.formModal.open();
                }
            } else if (isVideo) {
                shouldOpenResource = true;
            }

            if (shouldOpenResource) {
                this.openResource();
            }
        },
        formHasSubmitted() {
            if (this.hasMarketoCookie()
                && CoveoWebsite.forms.email) {
                this.closeModalAndOpenResource();
            }
        },
        setResourceDocumentUrlForCta() {
            if(this.data) {
                this.resourceDocumentUrlForCta = this.data.document;
            }
        },
        triggerFormModalClose() {
            this.$refs.formModal.close();
        },
        genericSuccessMessageOpenResource() {
            if (this.hasMarketoCookie() && CoveoWebsite.forms.email) {
                if(this.data) {
                    window.open(this.data.document, 'blank');

                    this.updateMarketoLeadAndPushDataLayer();
                }
            }
        },
        isVideoPlaylist() {
            return this.data.video.playlist && this.data.video.playlist.resourceVideos.length;
        },
        hasSpeakers() {
            return this.data.speakers && this.data.speakers.people && this.data.speakers.people.length;
        },
        hasDescription() {
            return this.data.description;
        },
        hasSidebarRenderings(hasSitecoreRenderings = 'false') {
            return hasSitecoreRenderings.toLowerCase() === 'true' || this.hasSpeakers();
        },
        getNextVideoMessageElement() {
            return this.$refs['nextVideoMessage']?.querySelector('[am-component="r360-hub-series-next-message"]');
        },
        updateMarketoLeadAndPushDataLayer() {
            if (this.hasMarketoCookie() && !this.resourceIsOpened) {
                const config = {
                    resource: this.data.resource,
                };

                this.updateMarketoLeadAndPushDataLayerCore(config);
            }
        },
        initSeriesVideoPage() {
            if (this.$refs.seriesVideosWrapper) {
                OverlayScrollbars(this.$refs.seriesVideosWrapper, {});

                this.$refs.seriesVideosWrapper.querySelectorAll('.series-video')
                    .forEach((video) => {
                        if (video.classList.contains('current')) {
                            video.scrollIntoView({ block: 'nearest', inline: 'start' });
                        }

                        const hoverVideoElement = video.querySelector('.series-video-hover-video video');

                        if (!hoverVideoElement?.dataset.src) {
                            return;
                        }

                        let shouldPlayHoverVideo = false;

                        video.addEventListener('mouseenter', () => {
                            shouldPlayHoverVideo = true;

                            if (!hoverVideoElement.src) {
                                hoverVideoElement.src = hoverVideoElement.dataset.src;
                            }

                            const waitForVideoInterval = setInterval(() => {
                                if (hoverVideoElement.readyState === 4) {
                                    if (shouldPlayHoverVideo) {
                                        hoverVideoElement.play();
                                        video.classList.add('video-hover-playing');
                                    }

                                    clearInterval(waitForVideoInterval);
                                }
                            }, 10);
                        });

                        video.addEventListener('mouseleave', () => {
                            shouldPlayHoverVideo = false;
                            video.classList.remove('video-hover-playing');
                            hoverVideoElement.pause();
                        });
                    });
            }
        },
    }
};